var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 627.56 418.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.9,59.37,53,358.2a7,7,0,0,0,6.95,7.55H91.57a7,7,0,0,0,7-6.61l2.6-49.72h18.08l2.6,49.72a7,7,0,0,0,6.95,6.61h37.47a7,7,0,0,0,6.94-7.6L146.26,59.32A7,7,0,0,0,139.32,53H84.84A7,7,0,0,0,77.9,59.37Zm26.17,204.22,6.31-119,6.31,119Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.13,169.43H361.9V101.32h47.27a7,7,0,0,0,7-7V60a7,7,0,0,0-7-7H315.48a7,7,0,0,0-7,7V358.78a7,7,0,0,0,7,7h70.81c21.86,0,37.83-11.35,37.83-41.2V211C424.12,182.88,407.73,169.43,387.13,169.43ZM372,317.4c0,4.63-1.26,8-6.3,8H361.9V211.88h3.79c4.2,0,6.3,3,6.3,8.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M563.66,317v-257a7,7,0,0,0-7-7H457.94a7,7,0,0,0-7,7c-.43,109.66-1.26,173.22-2.5,204.51-2.1,34.06-3.36,45-5.46,52.55h-.6a7,7,0,0,0-7,7v34.83a7,7,0,0,0,7,7H567.62a7,7,0,0,0,7-7V324a7,7,0,0,0-7-7Zm-52.13,1.27h-21c2.1-10.51,3.79-22.71,5.47-51.29,1.26-27.75,2.52-77.78,2.52-165.64h13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.36,186.66v74c-1.26,0-2.52.42-4.63.42h-.42c-3.78,0-6.3-1.26-6.3-7.57V59.94a7,7,0,0,0-7-7H184a7,7,0,0,0-7,7V265.27c0,32.37,19.76,44.15,43.72,44.15h.84c10.51,0,18.08-1.27,19.76-2.53v51.89a7,7,0,0,0,7,7h39a7,7,0,0,0,7-7V60a7,7,0,0,0-7-7h-39a7,7,0,0,0-7,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner7);
export default __webpack_public_path__ + "static/media/partner_7.f15985eabfefa926df1470a4502b5df7.svg";
export { ForwardRef as ReactComponent };